export const dataURLToFile = (dataurl: any, filename: any): File => {
  const arr = dataurl.split(",");
  const mime = arr[0].match(/:(.*?);/)![1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
};

// Helper function to format timestamp in UTC
export const formatTimestampUTC = (date: Date): string => {
  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are 0-based
  const year = date.getUTCFullYear();

  let hours = date.getUTCHours();
  const minutes = String(date.getUTCMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // Convert 0 to 12

  return `${month}-${day}-${year} ${hours}:${minutes} ${ampm} UTC`;
};

// Helper function to format timestamp in local time
export const formatTimestamp = (date: Date): string => {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // Convert 0 to 12

  return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
};

export const getTodayDate = (type?: string) => {
  const today = new Date();
  const year = today.getUTCFullYear();
  const month = String(today.getUTCMonth() + 1).padStart(2, "0");
  const day = String(today.getUTCDate()).padStart(2, "0");
  return `${day}-${month}-${year}`;
};

export const amountToGBP = (amount: number | string) => {
  if (!amount) return "";
  return amount.toLocaleString("en-GB", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const formatGBP = (value: number | string, type?: string) => {
  const num = typeof value === "string" ? parseFloat(value) : value;
  if (isNaN(num) || !value) return "";
  const formatted = num % 1 === 0 ? num.toFixed(0) : num.toFixed(2);
  if (type === "showMultiJobPopup") {
    return formatted;
  } else
    return new Intl.NumberFormat("en-GB", {
      minimumFractionDigits: formatted.includes(".") ? 2 : 0,
      maximumFractionDigits: 2,
    }).format(parseFloat(formatted));
};

export const formatGBPForAmountEntry = (value: number | string): string => {
  const num = typeof value === "string" ? parseFloat(value) : value;
  if (isNaN(num) || value === "" || value === null) return "";
  // Remove trailing zeros after decimal
  const str = Number(num).toString();
  return str.includes(".") ? str.replace(/\.?0+$/, "") : str;
};
